// extracted by mini-css-extract-plugin
export default {"activeOffers":"ActiveOffers_activeOffers__ntS-2","header":"ActiveOffers_header__nMWUl","offersList":"ActiveOffers_offersList__2dAwh"};